import ElectronicDocumentsServices from "../../services/ElectronicDocumentsServices";
const state = {
    loadingElectronicDocuments: false,            
    electronicDocumentsPaging: [],
    paginationElectronicDocuments: {
        descending: true,
        page: 1,
        rowsPerPage: 20,
        sortBy: 'cotizationDate',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
    },
    summary: {
        signed: 0,
        pendding: 0,
        error: 0,
        expired: 0
    },
    fileExcel: [],
    filePdf: [],
    electronicDocumentsDocumentItem: {
        state: "",
        outcome: "",
        documents: []
    }
};

const getters = {
    loadingElectronicDocuments: state => {
        return state.loadingElectronicDocuments;
    },            

    electronicDocumentsPaging: state => {
        return state.electronicDocumentsPaging;
    },

    paginationElectronicDocuments(state) {
        return state.paginationElectronicDocuments
    },    

    summary: state => {
        return state.summary;
    },

    electronicDocumentsFileExcel: state => {
        return state.fileExcel;
    }, 

    electronicDocumentsFilePdf: state => {
        return state.filePdf;
    }, 

    electronicDocumentsDocumentItem: state => {
        return state.electronicDocumentsDocumentItem;
    }, 
};

const actions = {

    getSummary(context, filters) {        
        context.commit("showElectronicDocumentsIndicator");      
        
        const profile = context.rootGetters.userProfile;
        const scopes = context.rootGetters.userScopes;

        filters.idAgencia = context.rootGetters.agencyId;
        filters.idUsuario = profile.user_id;        
        if(scopes.includes("aps_executive")){			
			filters.aps = context.rootGetters.business_name_executive
		}else{
			filters.aps = profile.business_name;
		}
        
        return ElectronicDocumentsServices.summary(filters)
            .then((res) => {
                if (res.data.error == 0) {                    
                    context.commit('_setSummary', {
                        summary : res.data.data
                    })
                } else {                   
                    context.commit('_setSummary', {
                        summary: {
                            signed: 0,
                            pendding: 0,
                            error: 0,
                            expired: 0
                        }
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideElectronicDocumentsIndicator");
            });
    },
    
    queryElectronicDocuments(context, filters) {        
        context.commit("showElectronicDocumentsIndicator");
        const {
           // sortBy,
            //descending,
            page,
            rowsPerPage
        } = context.state.paginationElectronicDocuments

        const profile = context.rootGetters.userProfile;
        const scopes = context.rootGetters.userScopes;

        filters.idAgencia = context.rootGetters.agencyId;
        filters.idUsuario = profile.user_id;

        if(scopes.includes("aps_executive")){			
			filters.aps = context.rootGetters.business_name_executive
		}else{
			filters.aps = profile.business_name;
        }
        filters.page = page;
        filters.limit = rowsPerPage;
        
        return ElectronicDocumentsServices.queryElectronicDocuments(filters)
            .then((res) => {                
                if (res.data.error == 0) {
                    const items = res.data.data.content;
                    const totalItems = res.data.data.total;
                    context.commit('_setElectronicDocumentsPaging', {
                        items,
                        totalItems
                    })
                } else {
                    const items = [];
                    const totalItems = 0;
                    context.commit('_setElectronicDocumentsPaging', {
                        items,
                        totalItems
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideElectronicDocumentsIndicator");
            });
    },

    downloadExcel(context, query) {        

        context.commit("showElectronicDocumentsIndicator");    
        
        const profile = context.rootGetters.userProfile;
        const scopes = context.rootGetters.userScopes;

        let aps = "";
        if(scopes.includes("aps_executive")){			
			aps = context.rootGetters.business_name_executive
		}else{
			aps = profile.business_name;
        }

        const userId = profile.user_id;
        const agencyId = context.rootGetters.agencyId;        

        return ElectronicDocumentsServices.downloadExcel(userId, agencyId, aps, query)
            .then(res => {
                state.fileExcel = res.data;
            })
            .finally(() => {
                context.commit("hideElectronicDocumentsIndicator");
            });
    },

    downloadPdf(context, query) {       

        context.commit("showElectronicDocumentsIndicator");    

        const profile = context.rootGetters.userProfile;
        const scopes = context.rootGetters.userScopes;

        let aps = "";
        if(scopes.includes("aps_executive")){			
			aps = context.rootGetters.business_name_executive
		}else{
			aps = profile.business_name;
        }

        const userId = profile.user_id;
        const agencyId = context.rootGetters.agencyId;          

        return ElectronicDocumentsServices.downloadPdf(userId, agencyId, aps, query)
            .then(res => {
                state.filePdf = res.data;
            })
            .finally(() => {
                context.commit("hideElectronicDocumentsIndicator");
            });
    },

    getDocuments(context, referenceId) {        

        context.commit("showElectronicDocumentsIndicator");              
        return ElectronicDocumentsServices.getDocuments(referenceId)
            .then((res) => {
                if (res.data.error == 0) {                    
                    console.log(res.data.data)
                    context.commit('_electronicDocumentsDocumentItem', {
                        electronicDocumentsDocumentItem : res.data.data
                    })
                } else {                   
                    context.commit('_electronicDocumentsDocumentItem', {
                        electronicDocumentsDocumentItem: {
                            state: "",
                            outcome: "",
                            documents: [],
                            lookupKey: "",
                            typeDocument: "",
                            signingParties: []
                        }
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideElectronicDocumentsIndicator");
            });
    },
    
};

const mutations = {
    showElectronicDocumentsIndicator(state) {
        state.loadingElectronicDocuments = true;
    },
    hideElectronicDocumentsIndicator(state) {
        state.loadingElectronicDocuments = false;
    },
    setElectronicDocumentsPaging(state, payload) {
        state.paginationElectronicDocuments = payload
    }, 
    _setElectronicDocumentsPaging(state, {
        items,
        totalItems
    }) {
        state.electronicDocumentsPaging = items
        state.paginationElectronicDocuments.totalItems = totalItems
    },
    _setSummary(state, { summary }) {
        state.summary = summary;
    },
    _electronicDocumentsDocumentItem(state, { electronicDocumentsDocumentItem }) {
        state.electronicDocumentsDocumentItem = electronicDocumentsDocumentItem;        
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};